import type { IGif } from '@giphy/js-types'

import { isKoddiApiAdGif } from '@/app/util/ads-util'
import { addNoFreestarParam, relativeUrl } from '@/util/url'

export const getGifNavigationUrl = (gif: IGif, suppressFreestarOnPromotedClick: boolean): string => {
    const destination = relativeUrl(gif.url)
    return suppressFreestarOnPromotedClick && isKoddiApiAdGif(gif) ? addNoFreestarParam(destination) : destination
}
